import { errorToast } from "components/Utils/Toast";

export const processError = (e: any) => {
    errorToast(e?.response?.status === 422
        ? e.response?.data?.result[0].msg
        : e.response?.data?.message || '')
}
